const translations = {
  FORMS: {
    EMAIL: 'Email',
    PASSWORD: 'Password',
    NAME: 'Name',
    SURNAME: 'Surname',
    REPEAT_PASSWORD: 'Repeat password',
    NEW_PASSWORD: 'New password',
    REPEAT_NEW_PASSWORD: 'Repeat new password',
    BIRTHDAY: 'Date of Birth',
    ID_NUMBER: 'ID Number',
    PHONE_NUMBER: 'Phone number',
    ADDRESS: 'Address',
    CITY: 'City',
    POSTAL_CODE: 'Postal Code',
    PROVINCE_STATE: 'Province / State',
    COUNTRY: 'Country',
    ACCEPT_CONDITIONS: 'I accept the conditions lorem ipsum',
    ARTIST_NAME: 'Artist name',
    APPLE_ID: 'Apple ID',
    SPOTIFY_ID: 'Spotify ID',
  },
  LOGIN: {
    WELCOME_BACK: 'Welcome Back',
    FORGOT_PASSWORD: 'Forgot password?',
    LOG_IN: 'Log In',
    DO_NOT_HAVE_ACCOUNT_YET: 'Don`t have an account yet?',
    SIGN_UP: 'Sign Up',
    ABOUT_US: 'About us',
    TERMS_CONDITIONS: 'Terms and conditions',
    PRIVACY_POLICY: 'Privacy Policy',
    SIGN_IN_GOOGLE: 'Sign in with Google',
  },
  SIGN_UP: {
    CHOOSE_THE_BEST_SUBSCRIPTION: 'Choose the best subscription',
    ALL_RIGHTS: 'All Rights',
    PUBLISHING_RIGHTS: 'Publishing Rights',
    STEP_1: 'Step 1',
    STEP_2: 'Step 2',
    DIGITAL_DISTRIBUTION: 'Digital distribution',
    SELECT: 'Select',
    ACCOUNT_INFORMATION_AND_PAYMENT: 'Account information and payment',
    ACCOUNT_INFORMATION: 'Account information',
    ORDER_SUMMARY: 'Order summary',
    PAYMENT: 'Payment',
    SUBMIT_PAYMENT: 'Submit payment',
    PAYMENT_INFORMATION: 'Payment information',
    SUBTOTAL: 'Subtotal',
    TOTAL: 'Total',
    SIGN_UP_GOOGLE: 'Sign up with Google',
    SIGNED_UP_GOOGLE: "You're signed up with Google",
    SIGN_UP_EMAIL: 'Sign up with email',
    ALREADY_ACCOUNT: 'You already have an account?',
    IDCARD: 'ID Card',
    DOCUMENTS: 'Documents',
    SELECTED_ITEM: 'Selected item',
    CARD_NUMBER: 'Card number',
    CARD_HOLDER: 'Card holder name',
    EXP_DATE: 'Expiration date',
    SEC_CODE: 'Security code',
    SUB_COMPLETED: 'You completed the Subsription successfully!',
    SUB_ITEM: 'Subscription item',
    SIGN_UP_COMPLETED: 'You completed the signup successfully!',
    CONTRACT_SENT: 'We have sent the contract to the email address provided.',
    CHECK_EMAIL_AND_LOGIN:
      'Please check your email and log in with the registered user.',
    CORRECT_FRONT_ID: 'Correct Front side ID',
    CORRECT_BACK_ID: 'Correct Back side ID',
    CORRECT_SELFIE: 'Correct Selfie',
    PLEASE_COMPLETE_SIGNUP: 'Please, complete your sign up.',
    COMPLETE_SIGNUP: 'Complete sign up',
  },
  BUTTON: {
    SAVE_CHANGES: 'Save changes',
    ADD: 'Add',
    ADD_NEW_TRACK: 'Add new track',
    ADD_SONG: 'Add Song',
    ADD_RELEASE: 'Add Release',
    ADD_SINGLE: 'Add new Single',
    ADD_EP: 'Add new EP',
    LEARN_MORE: 'Learn more',
    ADD_AUTHOR_COMPOSER: 'Add Author / Composer',
    ADD_ALBUM: 'Add new Album',
    ADD_ARTIST: 'Add Artist',
    NEW_SINGLE: 'New Single',
    NEW_EP: 'New EP',
    NEW_ALBUM: 'New Album',
    SAVE_ADD: 'Save and Add',
    SAVE_ADD_TRACK: 'Save and Add new track',
    NEW_RELEASE: 'New Release',
    DELETE: 'Delete',
    VALIDATE: 'Validate',
  },
  NAVBAR: {
    DASHBOARD: 'Dashboard',
    MY_SONGS: 'My Songs',
    MY_RELEASES: 'My Releases',
    MUSIC_USAGE: 'Music Usage',
    EARNINGS: 'Earnings',
    HELP: 'Help',
    ROYALTIES: 'Royalties',
    STATEMENTS: 'Statements',
  },
  RESET_PASSWORD: {
    DID_YOU_FORGOT_PASSWORD: 'Did you forgot your password?',
    ENTER_YOUR_EMAIL_INSTRUCTIONS:
      'Please enter your email below to receive the instructions to reset your password.',
    EMAIL: 'Email',
    WRITE_EMAIL: 'Write email',
    SEND_RESET_EMAIL: 'Send password reset email',
    EMAIL_SENT: 'Email Sent',
    EMAIL_SENT_WITH_INSTRUCTIONS_1:
      'We have sent an email to the email address provided.',
    EMAIL_SENT_WITH_INSTRUCTIONS_2:
      'Please check your email and follow the instructions.',
    GO_TO_LOGIN: 'Go to Log in',
    NEW_PASSWORD: 'New password',
    ENTER_NEW_PASSWORD: 'Please enter your new password to change it.',
    YOUR_PASSWORD_HAS_BEEN_CHANGED: 'Your password has been changed!',
    YOU_CAN_LOGIN: 'You can login with your new password.',
    PASSWORDS_DO_NOT_MATCH: 'Passwords do not match!',
    ERROR_RESET_PASSWORD: 'Something went wrong while resetting the password!',
  },
  ACCOUNT: {
    PROFILE_INFO: 'Profile Information',
    SUBSCRIPTION: 'Subscription',
    FINANCIAL_DATA: 'Financial data',
    LOG_OUT: 'Logout',
  },
  PAGE_TITLE: {
    TOP_EARNING_WORKS: 'Top earning works',
    MUSIC_USAGE_DETAIL: 'Usage details',
    PROFILE: 'Profile',
  },
  PROFILE_INFO: {
    NAME: 'Name',
    EMAIL: 'Email',
    SAVE_CHANGES: 'Save changes',
    PASSWORD: 'Password',
    CHANGE_PASSWORD: 'Change password',
    CANCEL: 'Cancel',
    SAVE: 'Save',
    VALIDATE_EMAIL: 'You need to validate your email',
    VALIDATE_EMAIL_BUTTON: 'Send validation email',
    USER_DISTRIBUTION: 'User distribution',
    ADD_PAYMENT_METHOD: 'Add payment method',
    REVELATOR_ACCOUNT_CREATED: 'Revelator account created',
  },
  PROFILE_PAGES: {
    PROFILE: 'Profile',
    PROFILE_INFO: 'Profile Information',
    SUBSCRIPTION: 'Subscription',
    FINANCIAL_DATA: 'Financial data',
    USER_DISTRIBUTION: 'User distribution data',
    CONTRACTS: 'Contracts',
  },
  FINANCIAL_DATA: {
    BANK_INFO: 'Bank information',
    BANK_ACCOUNT_TEXT:
      'The back account you provide in this section is very important, as it’s where you will receive the royalties for your work',
    CIF_NIF: 'CIF/NIF',
  },
  SUBSCRIPTION_INFO: {
    YOUR_NEXT: 'Your next ',
    BILL_DATE: ' bill is due ',
    PAYMENT_METHOD: 'Payment method',
    PAYMENT_METHOD_TEXT:
      'This is the payment method you used when you subscribed',
    EDIT: 'Edit',
    ALL_RIGHTS: 'All Rights',
    DISTRIBUTION: 'Distribution Rights',
    ALL_RIGHTS_DETAIL: '(Publishing & Digital Distribution)',
    DISTRIBUTION_DETAIL: '(Digital Distribution)',
    MANAGE_SUBSCRIPTION: 'Manage subscription',
    SUBSCRIPTION_KNOW_MORE: 'Know more about the subscription type',
    SUBSCRIPTION_RENEWED_ON: 'Your subscription will be renewed on ',
    ADD_PAYMENT_METHOD: 'Add payment method',
    SET_AS_DEFAULT: 'Set as default',
    STATUS: 'Status',
    CANCEL_SUBSCRIPTION: 'Cancel subscription',
  },
  FINANCIAL_DATA_INFO: {
    USER_TYPE: 'Type of user',
    BANK_INFO: 'Bank information',
    COUNTRY: 'Country',
    CURRENCY: 'Currency',
    BANK_ACCOUNT: 'Banck account',
    SWIFT: 'Swift',
    SELECT: 'Select Here',
    COMPANY: 'Company',
    INDIVIDUAL: 'Individual',
    SELF_EMPLOYED: 'Self employed',
    company: 'company',
    individual: 'individual',
    self_employed: 'self_employed',
  },
  WORK_STATUS: {
    ACCEPTED: 'ACCEPTED',
    CONFLICT: 'CONFLICT',
  },
  WORK_TYPE: {
    SINGLE_MIN: 'Single',
    ALBUM_MIN: 'Album',
    SINGLE: 'SINGLE',
    ALBUM: 'ALBUM',
    EP: 'EP',
  },
  WORKS_PAGES: {
    MY_SONGS: 'My Songs',
    MY_RELEASES: 'My Releases',
    ALBUM_DATA: 'Album data',
    MUSICAL_RELEASE: 'Musical Release',
    TRACKS: 'Tracks',
    DIGITAL_DISTRIBUTION: 'Digital distribution',
    ALBUM_DETAILS: 'Album details',
    RELEASE_DETAILS: 'Release details',
    EDIT_DETAILS: 'Edit details',
    EDIT_TRACKS: 'Edit tracks',
    EDIT_DIGITAL_DISTRIBUTION: 'Edit digital distribution',
    EDIT_DISTRIBUTION: 'Edit distribution',
    ADD_ALBUM_TRACKS: 'Add Album tracks',
    ADD_SINGLE_TRACKS: 'Add Single tracks',
    ADD_RELEASE_TRACKS: 'Add Release tracks',
    ADD_EP_TRACKS: 'Add EP tracks',
    ADD_EXISTING_TRACK: 'Add existing track',
    TERRITORY_RESTRICTIONS: 'Territory restrictions',
    CHANGE_RESTRICTION: 'Change restriction',
    CHANGE_RESTRICTION_WARNING:
      'The changes will only affect digital distribution rights.',
    ALL_TERRITORIES: 'All territories / countries',
    SPECIFIC_TERRITORIES: 'Specific territories / countries',
    BACK: 'Back',
    BACK_TO_TRACKS: 'Back to tracks',
    TRACK_DETAILS: 'Track Details',
    SEE_MORE: 'See more',
    SEE_LESS: 'See less',
    ARTIST_PERFORMER: 'Artist / Performer',
    AUTHOR_COMPOSERS: 'Author / Composers',
    AUTHOR_COMPOSER: 'Author / Composer',
    COMPOSER_ID: 'Composer ID',
    COMPOSER_IPI: 'Composer IPI',
    ADD_NEW_AUTHOR_COMPOSER: 'Add new Author / Composer',
    AUTHOR_COMPOSER_DATA: 'Author/Composer data',
    CREATE_AUTHOR_COMPOSER: 'Create a new Author / Composer',
    AUTHOR_COMPOSER_RULES: 'Author / Composer rules',
    SEARCH_AUTHOR_COMPOSER: 'Search existing Author / Composer',
    SEARCH_NAME_COMPOSERID: 'Search by name or ComposerID',
    FULLNAME: 'Full Name',
    TOTAL: 'Total',
    SELECT_ALL_STORES: 'Select all the digital stores',
    STORES_SELECTED: 'Stores selected',
    APPLE_ID: 'Do you have an Apple Music ID?',
    NO_ID: 'No, I need you to assign me one',
    SPOTIFY_ID: 'Do you have an Spotify ID?',
    NEW_TRACK: 'New track',
    EDIT_TRACK: 'Edit track',
    TYPES_OF_ROLE: 'Types of role',
    SONG_EDITED: 'This song is edited by a music publishing',
    NEED_ISRC: 'I need you to assign an ISRC',
    HAVE_ISRC: 'I have an ISRC',
    HAVE_LICENSE:
      'Have you obtained a license for this version that specifically authorizes digital distribution?',
    NO_LICENSE:
      'All cover versions require a valid license to be distributed through. SOLO is not responsible if you don’t have a license lorem ipsum dolor secit.',
    IPI: 'IPI',
    RELEASE_NOT_FOUND: 'Release not found',
    LOADING_RELEASE: 'Loading release..',
    PUBLISHER_NAME: 'Publisher name',
    PUBLISHING_TYPE: 'Publishing type',
  },
  WORKS: {
    APPLY_FILTERS: 'Apply filters',
    SEARCH_BY: 'Search by title, Unison ID',
    FILTER: 'Filter ',
    SEARCH: 'Search',
    TYPE: 'Type',
    STATUS: 'Status',
    EXPEDITION_DATE: 'Expedition date',
    STATEMENTS_STATUS: {
      CREATED: 'Created',
      SENT: 'Sent',
      PAID: 'Paid',
      NO_BANK_ACCOUNT: 'No bank account',
    },
    ISWC: 'ISWC',
    UNISON_ID: 'Unison Id',
    COVER_IMAGE: 'Cover Image',
    ALBUM_TITLE: 'Album title',
    RELEASE_TITLE: 'Release title',
    SINGLE_TITLE: 'Single title',
    EP_TITLE: 'EP title',
    ARTIST_NAME: 'Artist name',
    MAIN_ARTIST: 'Main Artist',
    OTHER_ARTISTS: 'Other artist',
    OTHER_ARTISTS_NAME: 'Other artist name',
    CONTRIBUTORS: 'Contributors',
    VARIOUS_ARTIST: 'Various artists',
    LANGUAGE: 'Language',
    LABEL_NAME: 'Record label',
    UPC_EAN: 'UPC / EAN',
    RELEASE_DATE: 'Release date',
    RELEASE_TIME: 'Release time',
    RELEASED_AT: 'Released at',
    PRIMARY_GENRE: 'Primary genre',
    SECONDARY_GENRE: 'Secondary genre',
    CHOOSE_GENRE: 'Choose a genre',
    PRODUCT_COPYRIGHT: 'Product copyright',
    PRODUCT_COPYRIGHT_YEAR: 'Product copyright year',
    SOUND_RECORDING_COPYRIGHT: 'Sound recording copyright',
    SOUND_RECORDING_COPYRIGHT_YEAR: 'Sound recording copyright year',
    COPYRIGHT_FORMAT_ERROR: 'The format must be: YYYY {TEXT}',
    TITLE: 'Title',
    ARTIST: 'Artist',
    TRACKS: 'Tracks',
    RELEASE: 'Release',
    SINGLE: 'Single',
    ALBUM: 'Album',
    SEARCH_BY_TITLE: 'Search by title',
    TASKS: 'Tasks',
    SUMMARY: 'Summary',
    ALBUM_DETAILS: 'Album details',
    EP_DETAILS: 'EP details',
    SINGLE_DETAILS: 'Single details',
    ALBUM_DATA: 'Album data',
    EP_DATA: 'EP data',
    SINGLE_DATA: 'Single data',
    ACTIONS: 'Actions',
    ADD_RELEASE_SUBTITLE:
      'Start your journey to share your latest musical creation. Click below to add a new release and showcase your sound to the world.',
    ARTWORK: 'Artwork',
    URL_ARTWORK: 'URL Artwork',
    ARTWORK_SUBTITLE:
      'Provide a visually compelling image that represents your musical release. This artwork will be featured across your release’s profile, helping you capture the essence of your sound and attract new listeners. Please ensure the image meets our size and format requirements.',
    UPC_INFO:
      "If you already have a UPC for this version, please add. If not, no problem, we'll create one for you.",
    INCLUDE: 'Include',
    EXCLUDE: 'Exclude',
    INCLUDE_EXCLUDE: 'Include / Exclude',
    TERRITORY: 'Territory',
    MODIFICATOR: 'Modificator',
    WORLD: 'World',
    LOADING: 'Loading',
    RELEASE_SUCCESS: 'Musical release successfully created!',
    UPLOAD: 'Upload',
    DROP_FILE: 'or drop file here.',
  },
  TRACKS: {
    TRACK_TITLE: 'Track title',
    ORDER: 'Order',
    ALTERNATIVE_TITLE: 'Alternative title',
    COMPOSITION_TYPE: 'Composition type',
    LANGUAGE_LYRICS: 'Language of the lyrics',
    EXPLICIT_CONTENT: 'Explicit content',
    ISRC: 'ISRC',
    AUDIO: 'Audio',
    AUDIO_FILE: 'Audio File',
    LYRICS: 'Lyrics',
    ARTIST: 'Artist',
    ROLE: 'Role',
    IPI: 'IPI',
    SHARES: 'Shares',
    YES: 'Yes',
    NO: 'No',
    ORIGINAL: 'Original',
    ORIGINAL_ARTIST: 'Original song artist',
    ORIGINAL_SONG_DETAILS: 'Original song details',
    ORIGINAL_TITLE: 'Original song title',
    MISSING_ARTIST: 'You need to assign at least one artist.',
    MISSING_AUTHOR: 'You need to assign at least one autor or composer.',
    SURE_DELETE: 'Are you sure you want to delete ',
    PROPERTIES: 'Properties',
  },
  DIGITAL_DISTRIBUTION: {
    PLATFORM: 'Platform',
    DATE: 'Date',
    STATUS: 'Status',
    DIGITAL_DISTRIBUTION: 'Digital distribution',
    APPLY: 'Apply',
    VALIDATION_STATUS: 'Validation status:',
    DISTRIBUTION: 'Distribution',
    SALE_START_DATE: 'Sale start date',
    SALE_START_TIME: 'Sale start time',
    APPLE_MUSIC: 'Apple Music',
    SPOTIFY: 'Spotify',
    DISTRIBUTE: 'Distribute',
    VALIDATION_ERRORS: 'Validation Errors',
    ENUM_STATUS: {
      VALIDATED: 'Validated',
      PENDING: 'Pending',
      ERROR: 'Error',
      DISTRIBUTED: 'Distributed',
      DISTRIBUTING: 'Distributing',
      CREATED: 'Not yet validated',
      VALIDATION_FAILED: 'Validation failed',
      'VALIDATION FAILED': 'Validation failed',
    },
  },
  EARNINGS: {
    SEE_ALL: 'See all',
    TOP_WORKS: 'Top earning works',
    PUBLISHING: 'Publishing',
    DIGITAL_DISTRIBUTION: 'Digital distribution',
    TOTAL: 'Total',
    TOP_REVENUE_DSP: 'Top revenue by DSP',
    TOP_REVENUE_COUNTRY: 'Top revenue by country',
    MONTHLY_REVENUE_PLATFORM: 'Monthly revenue by platform',
    ANUAL_REVENUE: 'Anual revenue',
    TOP_EARNING_WORKS: 'Top earning works',
    ROYALTIES_BY_WORK: 'Royalties by work',
    ALL: 'All',
    PERIOD: 'Period',
    AMOUNT: 'Amount',
  },
  USAGES: {
    DATE: 'Date',
    PLAYS: 'Plays',
    PLAYS_LOWER_CASE: 'plays',
    PLAYS_PLATFORM: 'Plays by platform',
    SEE_ALL: 'See all',
    USAGE_DETAILS: 'Usage detail',
    TOP_SONGS_PLATFORM: 'Top Songs',
    TOP_4_PLAYS_PLATFORMS: 'Top 4 plays platforms',
    USAGE_TREND: 'Music usage trend',
    NO_PLAYS_TO_SHOW: 'There are no plays to show',
    MOCK_DATA:
      'Note: The data displayed on this page is mocked for demonstration purposes.',
    NO_DATA: 'No data',
  },
  FILTERS: {
    FROM: 'From',
    TO: 'To',
    CLEAR_FILTERS: 'Clear filters',
    CLEAR_FILTER: 'Clear filter',
    CLOSE: 'Close',
    APPLY: 'Set date',
    APPLY_FILTERS: 'Apply filters',
    PERIOD: 'Select period',
    SEE: 'See',
    OF: 'of',
    PAGES: 'pages',
    RELEASES: 'releases',
    ELEMENTS: 'elements',
  },
  PAGINATOR: {
    JUMP_TO: 'Jump to page',
    SELECT_PAGE: 'select page',
  },
  ERROR: {
    USER_PASSWORD_NOT_MATCH: 'User or password do not match',
    UNEXPECTED_ERROR: 'Unexpected Error',
    NO_MAIL_REGISTERED: 'This emial is not registered',
  },
  HELP_PAGE: {
    WELCOME_TO_SOLORIGHTS: 'Welcome to SOLOrights',
    WELCOME_TO_SOLORIGHTS_DESCRIPTION:
      'Welcome to the inaugural open beta of SOLOrights. As you explore our live, evolving platform, please note that you are witnessing the first phase of an exciting journey aimed at redefining rights management.',
    WELCOME_TO_SOLORIGHTS_DESCRIPTION_2:
      'Our dedicated team is continuously working to enhance the system, address any challenges, and incorporate valuable feedback. During this beta phase, you may encounter features or areas still under active development.',
    WELCOME_TO_SOLORIGHTS_DESCRIPTION_3:
      'We deeply value your input and encourage you to share your insights, questions, or feedback with us. Please feel free to contact us at',
    WELCOME_TO_SOLORIGHTS_DESCRIPTION_4:
      'Thank you for your participation and support as we strive to deliver a state-of-the-art platform tailored to your needs. Enjoy your experience on SOLOrights.',
  },
  ACTIONS: {
    ACTIONS: 'Actions',
  },
  PAGINATION: {
    PAGE: 'Page',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    NEXT_STEP: 'Next step',
    JUMP_TO_PAGE: 'Jump to page',
    GO: 'Go',
  },
  TOAST: {
    CHANGES_SAVED: 'Changes saved!',
    CHANGES_ERROR: 'Something went wrong while saving changes!',
    DELETE_ERROR: 'Something went wrong while deleting!',
    LOAD_EARNINGS_ERROR: 'Something went wrong while loading your earnings!',
    MANDATORY_ERROR: 'All mandatory fields must be filled!',
    ALL_MANDATORY_ERROR: 'All fields are mandatory!',
    PASSWORD_ERROR: 'Passwords do not match!',
    SIGNATURIT_ERROR: 'Something went wrong when connecting to signaturit.',
    LOGIN_ERROR: 'Authentication failed.',
    CREATE_AUTHOR_ERROR: 'An error ocurred when creating the author.',
    LOAD_RECORDING_ERROR: 'Something went wrong while loading the recording!',
    PERF_100_ERROR: "Total performance percentage can't be over 100%!",
    MECH_100_ERROR: "Total mechanichal percentage can't be over 100%!",
    CARD_ERROR: "Couldn't retrieve your card information!",
    EMAIL_REQUESTED: 'Email requested successfully!',
    EMAIL_VALIDATION_ERROR:
      'Something went wrong while sending request to validate the email!',
    SUBSCRIPTION_ERROR: 'Something went wrong while creating the subscription!',
    VALIDATION_ERROR:
      'Something went wrong while validating the musical release!',
    MUSICAL_RELEASE_UPDATED: 'Musical release updated successfully!',
    MUSICAL_RELEASE_DELETED: 'Musical release deleted successfully!',
    TRACK_UPDATED: 'Track updated successfully!',
    TRACK_CREATED: 'Track created successfully!',
    AUTHOR_CREATED: 'Author created successfully!',
    TRACK_DELETED: 'Track deleted successfully!',
    TRACK_ERROR: 'Something went wrong while creating the track!',
  },
  DASHBOARD: {
    MY_SONGS_INSIGHT: 'My Songs insights',
    MY_RELESES_INSIGHT: 'My Releases insights',
    TOTAL_EPS: 'Total EPs',
    TOTAL_SINGLES: 'Total singles',
    TOTAL_ALBUMS: 'Total albums',
    TOTAL_RELEASES: 'Total releases',
    TOTAL_PENDING_AMOUNT: 'Total pending amount',
    PUBLISHING_REVENUE: 'Publishing revenue',
    DISTRIBUTION_REVENUE: 'Distribution revenue',
    VIEW_MY_RELEASES: 'View my releases',
    PLAYS_COUNTRY: 'Countries with more plays',
    TOP_3_EARNING_PLATFORMS: 'Top 3 earning platforms',
    MY_RELEASES_INSIGHT: 'My releases insights',
    HELP_TITLE: 'Frequently asked questions',
    HELP_SUBTITLE:
      'Explore our collection of frequently asked questions to find quick tips, detailed guidance, and support for managing your musical releases efficiently.',
    HELP_CARD_1_QUESTION: 'How do I add a new release?',
    HELP_CARD_1_ANSWER:
      'Start your journey to share your latest musical creation. Click "My Releases" to add a new release and showcase your sound to the world.',
    HELP_CARD_2_QUESTION:
      'What do the graphs and statistics on the dashboard represent?',
    HELP_CARD_2_ANSWER:
      'The visualizations provide real-time insights into your rights portfolio performance, revenue trends, and user activity so you can monitor key metrics at a glance.',
    HELP_CARD_3_QUESTION:
      'Who do I contact if I need support or have any questions?',
    HELP_CARD_3_ANSWER:
      'For assistance or further inquiries, please contact our support team via the information provided in the help section.',
  },
  DOWNLOAD: {
    DOWNLOAD: 'Download',
    GENERATING: 'Generating...',
    REQUEST: 'Request',
  },
  NOT_FOUND: {
    PAGE_NOT_FOUND: 'Page not found',
    SORRY: 'We are sorry, the page you requested could not be found',
    GO_BACK: 'Please go back to the ',
  },
  SIGNATURIT: {
    SIGN_DOC: 'Sign the document with electronic signature',
    START: 'Start',
    SIGN: 'Sign',
  },
  VERIFY_EMAIL: {
    EMAIL_VERIFIED: 'Email verified',
    EMAIL_VERIFIED_DESCRIPTION:
      'Email verified successfully, you can continue to the dashboard.',
    ERROR_VERIFY_EMAIL: 'Something went wrong while verifying the email!',
    GO_TO_DASHBOARD: 'Go to Dashboard',
  },
  AUTHOR_COMPOSER_RIGHTS: {
    INFO: {
      1: 'Copyright control',
      2: 'Published',
      3: 'Public domain',
    },
    1: 'Copyright control (self-published)',
    2: 'Published (managed by a publisher)',
    3: 'Public domain (no publisher)',
  },
  DISTRIBUTION_STATUS: {
    '-13': 'Rejected by inspector',
    '-11': 'Hidden',
    '-10': 'Pending approval',
    0: 'Pending',
    4: 'Waiting for download assets',
    5: 'Download assets',
    6: 'Download assets failed',
    8: 'Pending transformation',
    10: 'Transformation progress',
    11: 'Transformation failed',
    20: 'Waiting for validation',
    21: 'Validation failed',
    30: 'Waiting for package creation',
    31: 'Creating package',
    32: 'Creating package failed',
    40: 'Waiting for upload',
    41: 'Uploading',
    42: 'Uploading failed',
    50: 'Delivered',
    60: 'On store',
    70: 'Waiting for remove',
    71: 'Removing',
    72: 'Takedown uploading',
    75: 'Takedown waiting for revelator netcore',
    76: 'Takedown enqueued by revelator netcore',
    77: 'Removing failed',
    78: 'Remove delivered',
    79: 'Takedown processed',
    100: 'Process error',
  },
  TRACK_PROPERTIES: {
    1: 'None',
    2: 'Remix',
    3: 'Samples or stock',
    4: 'Mix or compilation',
    5: 'Alternate version',
    6: 'Special genre',
    7: 'Non-musical content',
    8: 'Includes AI',
  },
};

export default translations;
